import { Component } from '@angular/core';
import { ColumnDateDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-date',
  templateUrl: './ap-column-date.component.html',
})
export class ApColumnDateComponent extends ApColumnBase<ColumnDateDto> {
  displayDate: string;
  load() {
    this.displayDate = this.columnInfoDto.DateStringCallback(this.dataItem);
  }
}
